/**
 * @see https://github.com/prismicio/gatsby/blob/v3.3.6/docs/previews-api.md#using-locally-transformed-images
 */
export const makeImagePreviewable = (image) => {
  if (!image) {
    return undefined;
  }

  if (image.localFile) {
    return image;
  }

  const imageContent = {
    ...image,
    ...((image.gatsbyImageData || image.url) && {
      localFile: {
        childImageSharp: {
          gatsbyImageData: image.gatsbyImageData,
        },
        url: image.url,
        id: image.url,
      },
    }),
  };

  return imageContent;
};
